// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__13DFV","description":"PatientConsentPreview_description__M7tpR"};